import axios, { AxiosRequestConfig } from "axios";
import auth, { AuthServiceType } from "shared/Auth0";
import { BASE_API_URL } from "store/Me";

const baseURL = BASE_API_URL;

export default interface AbstractResponseModel<T> {
  data: T;
}

const getAuthHeaderValue = async (authResponse: AuthServiceType) => {
  // If user is logged in, get the token from the login provider.
  if (auth.isAuthenticated()) {
    return `Bearer ${localStorage.getItem("access_token")}`;
  }
};

const useMakeAuthedRequest = () => {
  const authResponse = auth;

  /**
   * Async function for sending request authorized with Auth0
   *
   * @param {Object} request object created by requestFactory.
   * @returns {Object} request response data as a Promise.
   */
  async function makeAuthedRequest<T = void>(
    request: Partial<AxiosRequestConfig>,
  ) {
    const { data } = await axios.request<T>({
      baseURL,
      ...request,
      headers: {
        ...request.headers,
        // Add the Authorization header to the existing headers
        Authorization: await getAuthHeaderValue(authResponse),
      },
    });

    return data;
  }

  return makeAuthedRequest;
};

export { useMakeAuthedRequest };

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (401 === error.response.status) {
      window.location.href = "/logout";
    } else {
      return Promise.reject(error.response.data?.Message);
    }
  },
);
